import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import FallacyPoem from './FallacyPoem';
import RefinedPoemTree from './MissMuffetPoemTree';
import NavLink from './NavLink';
import Home from './Home';
import GetReadyPoem from './ADHDMornings';
import UncoveringHope from './Hope';
import Bloom from './Bloom';
import VacuumPoem from './Vacuum';
import TwoWeeks from './TwoWeeks';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if we're on mobile and update state
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Initial check
    checkIfMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Close menu when a link is clicked (mobile only)
  const handleNavClick = () => {
    if (isMobile) {
      setMenuOpen(false);
    }
  };

  return (
    <Router>
      <div className="App">
        {/* Mobile Hamburger Button */}
        {isMobile && (
          <button 
            className="hamburger-menu"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <div className={`hamburger-icon ${menuOpen ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>
        )}
        
        {/* Mobile Menu Overlay */}
        {isMobile && (
          <div 
            className={`mobile-menu-overlay ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(false)}
          />
        )}
        
        {/* Navigation Menu */}
        <nav className={`poem-menu ${isMobile ? 'mobile' : ''} ${menuOpen ? 'open' : ''}`}>
          <NavLink to="/" onClick={handleNavClick} className="logo">
            Marie Emoji
          </NavLink>
          <NavLink to="/mulitmissmuffet" onClick={handleNavClick}>
            Multi Miss Muffet
          </NavLink>
          <NavLink to="/fallacy" onClick={handleNavClick}>
            Fallacy
          </NavLink>
          <NavLink to="/getready" onClick={handleNavClick}>
            Get Ready
          </NavLink>
          <NavLink to="/bloom" onClick={handleNavClick}>
            Bloom
          </NavLink>
          <NavLink to="/vacuum" onClick={handleNavClick}>
            Vacuum
          </NavLink>
          <NavLink to="/twoweeks" onClick={handleNavClick}>
            Two Weeks
          </NavLink>
        </nav>
        
        <div className="poem-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mulitmissmuffet" element={<RefinedPoemTree />} />
            <Route path="/fallacy" element={<FallacyPoem />} />
            <Route path="/getready" element={<GetReadyPoem />} />
            <Route path="/bloom" element={<Bloom />} />
            <Route path="/vacuum" element={<VacuumPoem />} />
            <Route path="/twoweeks" element={<TwoWeeks />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;